import React, { useEffect, useState } from 'react'
import KrwPrice from '../../KrwPrice'
import Default from './Default'
import { useTradePosition } from '../../../hooks/trade/tradePosition'

const RealizePnl = () => {
	const [isLoading, setIsLoading] = useState(true)
	const { total_trade_price, data: position } = useTradePosition()
	const realizepnl = total_trade_price || 0

	useEffect(() => {
		const hasAllData = position !== undefined

		if (hasAllData) {
			setIsLoading(false)
		}
	}, [position])

	return (
		<Default
			title={'실현손익'}
			loading={isLoading}
			value={
				<KrwPrice
					margin={true}
					price={realizepnl || 0}
					dp={0}
					krw={false}
				/>
			}
		/>
	)
}

export default React.memo(RealizePnl)
